<script>
  import {getContext, onMount} from 'svelte';
  import lang from './ThreeMonthsTipsDialog.lang';
  import {mc} from '@/core';
  import {Modal} from '@/widgets';

  const LG = getContext('LG');

  export let visible = false;

  onMount(() =>
    mc.subscribe('three-months-tip', 'dialog-show', () => {
      visible = true;
    })
  );
</script>

{#if visible}
  <Modal {visible} size="small">
    <div class="lh24 df b f16 T2 jcsb" slot="header">
      <div class="lh24 fw2 f18 T1">{LG(lang.ExportFailed)}</div>
      <i class="iconfont lh12 f12 T4 cp" on:click={() => (visible = false)}>&#xe614;</i>
    </div>
    <div class="mt24 df fdc aic mb24">
      <div class="mt16 tc lh22 T2">{LG(lang.SixMonthsTips)}</div>
    </div>
  </Modal>
{/if}
